import type { TFunction } from 'i18next'

import { invoiceDisplayedTypeToTitleKey } from '../constants/invoiceDisplayedTypeToTitleKey'
import { InvoiceDisplayedType } from '../enums/invoiceDisplayedType'

export const getInvoiceDisplayedTypeLabel = (displayedType: InvoiceDisplayedType, t: TFunction): string => {
  return t(invoiceDisplayedTypeToTitleKey[displayedType])
}
